"use client";

import { BookingBranchLocationPicker } from "@/components/booking/BookingBranchLocationPicker";

type BookingReturnLocationPickerProps = {
  pickupLocation: string;
  value: string;
  onValueChange: (value: string) => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onReturnAtPickup: () => void;
  id?: string;
};

export function BookingReturnLocationPicker({
  pickupLocation,
  value,
  onValueChange,
  open,
  onOpenChange,
  onReturnAtPickup,
  id,
}: BookingReturnLocationPickerProps) {
  return (
    <BookingBranchLocationPicker
      id={id}
      mode="return"
      value={value}
      onValueChange={onValueChange}
      open={open}
      onOpenChange={onOpenChange}
      pickupLocation={pickupLocation}
      onReturnAtPickup={onReturnAtPickup}
      placeholder="Choose branch..."
      emptyDetailMessage="Select a return location to see branch details."
    />
  );
}
